import { render, staticRenderFns } from "./search-overlay.vue?vue&type=template&id=a22639a6&scoped=true&"
import script from "./search-overlay.vue?vue&type=script&lang=js&"
export * from "./search-overlay.vue?vue&type=script&lang=js&"
import style0 from "./search-overlay.vue?vue&type=style&index=0&id=a22639a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22639a6",
  null
  
)

export default component.exports